import { Grid, TextField, Typography } from "@mui/material";

import Textarea from "components/Textarea";
import { isRTL } from "utils/helpers/isRTL";
import { useFormContext } from "react-hook-form";
import { useMemo } from "react";

function WithdrawNetworkProposalMemo({ currentNetworkFields }) {
  const { watch, setValue } = useFormContext();
  const proposal = watch("proposal");
  const tagOrMemo = watch("tagOrMemo");

  const proposalIsRTL = useMemo(() => {
    return isRTL(proposal);
  }, [proposal]);

  return (
    <>
      {currentNetworkFields?.isHaveProposal && (
        <Grid item xs={12}>
          <Typography variant="h6" color="text.main">
            Proposal
          </Typography>

          <Textarea
            textAlign={proposalIsRTL ? "right" : "left"}
            dir={proposalIsRTL ? "rtl" : "ltr"}
            value={proposal}
            onChange={(e) => setValue("proposal", e.target.value)}
          />
        </Grid>
      )}

      {currentNetworkFields?.isHaveTagOrMemo && (
        <Grid item xs={12}>
          <Typography variant="h6" color="text.main">
            Tag or Memo
          </Typography>

          <TextField
            value={tagOrMemo}
            onChange={(e) => setValue("tagOrMemo", e.target.value)}
          />
        </Grid>
      )}
    </>
  );
}

export default WithdrawNetworkProposalMemo;
